import { ContextualSaveBar } from '@shopify/polaris';

interface NonembeddedSaveBarProps {
  open: boolean;
  loading?: boolean;
  disabled?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  disableDiscard?: boolean;
}

const NonEmbeddedSaveBar = ({ open, loading, disabled, onSave, onDiscard, disableDiscard }: NonembeddedSaveBarProps) => {
  if (!open) return null;

  return (
    <ContextualSaveBar
      message="Unsaved changes"
      saveAction={{
        onAction: onSave,
        loading,
        disabled,
      }}
      discardAction={{
        onAction: onDiscard,
        disabled: !!loading || disableDiscard,
      }}
    />
  );
};

export default NonEmbeddedSaveBar;
